import { useState } from "react";

import { useToast } from "sj-ui-toolkit/src/hooks";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

interface SendTestEmailDialogProps {
  visible: boolean;
  onHide: () => void;
  onSend: (email: string, templateName: string) => Promise<void>;
  templateName: string;
  templateTitle: string;
}

export const SendTestEmailDialog = ({
  visible,
  onHide,
  onSend,
  templateName,
  templateTitle,
}: SendTestEmailDialogProps) => {
  const { showToast } = useToast();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      showToast({ severity: "warn", detail: "Please enter an email address" });
      return;
    }

    if (loading) return;
    setLoading(true);

    try {
      await onSend(trimmedEmail, templateName);
      setEmail("");
      onHide();
    } finally {
      setLoading(false);
    }
  };

  const handleHide = () => {
    setEmail("");
    onHide();
  };

  const footer = (
    <div className="flex justify-end gap-2">
      <Button label="Cancel" severity="secondary" onClick={handleHide} disabled={loading} />
      <Button label="Send" icon="pi pi-send" onClick={handleSend} loading={loading} />
    </div>
  );

  return (
    <Dialog
      header="Send Test Email"
      draggable={false}
      visible={visible}
      style={{ width: "450px" }}
      onHide={handleHide}
      footer={footer}
    >
      <form
        onSubmit={e => {
          e.preventDefault();
          void handleSend();
        }}
      >
        <div className="flex flex-col gap-4">
          <p>
            Send a test email for the <strong>{templateTitle}</strong> template.
          </p>
          <InputText
            id="email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Enter email address"
            aria-label="Recipient email address"
            autoFocus
          />
        </div>
      </form>
    </Dialog>
  );
};
